export default {
      id: "add-alt-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#add-alt",
      toString: function () {
        return this.url;
      }
    }